import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import MedicalExamDTO from '../../../../dto/MedicalExamDTO';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';

export default function MedicalExamForm(props) {
  const { control, formMeta } = props;
  const dto = new MedicalExamDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_registry_number}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_inn}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          type="text"
          dtoObject={attributes.pre_trip_medical_exam_using}
          variant="material"
          component={CustomSelectInput}
          withLabel
          options={[{ value: '', name: ' ' }, { value: 'true', name: 'Используется' }, { value: 'false', name: 'Не используется' }]}
          formMeta={formMeta}
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          type="text"
          dtoObject={attributes.post_trip_medical_exam_using}
          variant="material"
          component={CustomSelectInput}
          withLabel
          options={[{ value: '', name: ' ' }, { value: 'true', name: 'Используется' }, { value: 'false', name: 'Не используется' }]}
          formMeta={formMeta}
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          type="text"
          dtoObject={attributes.pre_trip_technical_inspection_using}
          variant="material"
          component={CustomSelectInput}
          withLabel
          options={[{ value: '', name: ' ' }, { value: 'true', name: 'Используется' }, { value: 'false', name: 'Не используется' }]}
          formMeta={formMeta}
        />
      </Row>
    </>
  );
}
